'use client'

import { z } from 'zod'

import { useCachedSWR } from '@/core/lib/swr/use-cached-swr'
import { useAppReadScope } from '@/features/veluvit/hooks/use-app-read-scope'
import { appSwrKey } from '@/features/veluvit/lib/app-read'

const announcementSchema = z.object({
  enabled: z.boolean(),
  version: z.number().optional(),
  title: z.string().optional(),
  text: z.string().optional(),
  severity: z.enum(['info', 'incident', 'maintenance']).optional(),
  imageUrl: z.string().optional(),
  linkUrl: z.string().optional(),
})

export type Announcement = z.infer<typeof announcementSchema>

export function useAnnouncement(): Announcement | undefined {
  const epoch = useAppReadScope()
  const { data } = useCachedSWR<Announcement>(
    epoch ? appSwrKey(epoch, '/announcement/') : null,
    'REALTIME',
    { responseSchema: announcementSchema }
  )
  return data?.ok ? data.data : undefined
}
